export var code = function (text) {
    return "{{" + text + "}}";
};
//# sourceMappingURL=code.js.map